import { render, staticRenderFns } from "./FilesTab.htm?vue&type=template&id=939fea60&scoped=true&"
import script from "./FilesTab.ts?vue&type=script&lang=js&"
export * from "./FilesTab.ts?vue&type=script&lang=js&"
import style0 from "./FilesTab.scss?vue&type=style&index=0&id=939fea60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939fea60",
  null
  
)

export default component.exports